import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PurchaseService from "../../../services/OrderingServices/PurchaseService";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { formatDateTimes } from "../../../Components/Common/FormatDate";
import { Triangle } from "react-loader-spinner";

const PurchaseDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await PurchaseService.detail(id);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const breadcrumbItems = [
    { title: "Back To List", onClick: () => navigate(-1) },
  ];

  if (loading) {
    return (
      <Container fluid>
        <div className="page-content">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "400px" }}
          >
            <div className="text-center">
              <Triangle
                visible={true}
                height="80"
                width="80"
                color="#5B71B9"
                ariaLabel="triangle-loading"
              />
              <h5 className="mt-3">Loading...</h5>
            </div>
          </div>
        </div>
      </Container>
    );
  }

  const NumberWithCommas = ({ value }) => {
    if (value === undefined || value === null) return "0";
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Purchase Detail"
          pageTitle="Purchase"
          breadcrumbItems={breadcrumbItems}
        />

    <Row>
  <Col lg={12}>
    <Card id="demo">
      <CardBody>
        <Row className="p-3">
          {/* Header Section */}
          <Col lg={12}>
            <div className="mt-3 d-flex align-items-center justify-content-between mb-4">
              <h5 className="mb-0">Purchase Order #{data?.id}</h5>
              <div>
                <button
                  className="btn btn-success btn-sm me-2"
                  onClick={() => window.print()}
                >
                  <i className="ri-printer-line align-bottom me-1"></i> Print
                </button>
              </div>
            </div>
          </Col>

          {/* Information Section */}
          <Col lg={12}>
            <Card className="border-0 shadow-none mb-0">
              <CardBody className="p-0">
                <Row className="g-3">
                  <Col xs={6}>
                    <h6 className=" text-uppercase fw-bold mb-3">
                      Purchase Information
                    </h6>
                    <p className="text-muted fw-medium mb-2">Purchase Date:</p>
                    {/* <p className="text-muted mb-1">
                      {formatDateTimes(data?.purchaseDate)}
                    </p> */}
                    <p className="text-muted mb-0">{data?.purchaseDate_Nep} (BS)</p>
                  </Col>

                  <Col xs={6}>
                    <h6 className="text-uppercase fw-bold mb-3">
                      Supplier Details
                    </h6>
                    <p className=" text-muted fw-medium mb-2">{data?.supplierName}</p>
                    <p className="text-muted mb-1">
                      Contact: {data?.supplierContact}
                    </p>
                  </Col>

                  <Col xs={12}>
                    <div className="d-flex gap-2">
                      <span
                        className={`badge ${
                          data?.status === "Pending"
                            ? "bg-warning"
                            : data?.status === "Completed"
                            ? "bg-success"
                            : "bg-info"
                        } fs-11`}
                      >
                        Status: {data?.status}
                      </span>
                      <span
                        className={`badge ${
                          data?.paymentStatus === "Pending"
                            ? "bg-warning"
                            : data?.paymentStatus === "Paid"
                            ? "bg-success"
                            : "bg-danger"
                        } fs-11`}
                      >
                        Payment: {data?.paymentStatus}
                      </span>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          {/* Items Table Section */}
          <Col lg={12} className="mt-4">
            <Card className="border-0 shadow-none mb-0">
              <CardBody className="p-0">
                <div className="table-responsive">
                  <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                    <thead>
                      <tr className="table-active">
                        <th>S.N</th>
                        <th className="text-start">Product Details</th>
                        <th className="text-end">Unit Price</th>
                        <th className="text-end">Quantity</th>
                        <th className="text-end">Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.items?.map((item, index) => (
                        <tr key={item.id}>
                          <th>{index + 1}</th>
                          <td className="text-start">
                            <Link
                              to={`/item/detail/${item.productId}`}
                              className="fw-medium text-primary"
                            >
                              {item.productName}
                            </Link>
                          </td>
                          <td className="text-end">Rs. {item.unitPrice.toFixed(2)}</td>
                          <td className="text-end">{item.quantity}</td>
                          <td className="text-end">
                            Rs.{" "}
                            <NumberWithCommas value={item.totalPrice.toFixed(2)} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                {/* Total Section */}
                <div className="border-top border-top-dashed mt-2 d-flex justify-content-end">
                  <Table
                    className="table-borderless table-nowrap mb-0"
                    style={{ width: "300px" }}
                  >
                    <tbody>
                      <tr>
                        <td>Sub Total</td>
                        <td className="text-end">
                          Rs.{" "}
                          <NumberWithCommas value={data?.totalAmount.toFixed(2)} />
                        </td>
                      </tr>
                      <tr className="border-top border-top-dashed fs-15">
                        <th>Total Amount</th>
                        <th className="text-end">
                          Rs.{" "}
                          <NumberWithCommas value={data?.totalAmount.toFixed(2)} />
                        </th>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </CardBody>
    </Card>
  </Col>
</Row>

      </div>
    </Container>
  );
};

export default PurchaseDetail;
